import lottie from '../module/animation/lottie';

class Animation {
    constructor() {
        this.industryJson = {};

        $('[id^="animIndustry_"]').each((i, item) => {
            ZoneObject.create('#' + $(item).attr('id'), {
                minWidth: 0,
                run: (elem) => {
                    var id = elem.attr('id'),
                        num = id.split('_'),
                        num = num[1];

                    if (typeof this.industryJson[id] !== 'undefined') {
                        this.industryJson[id].play();
                    } else {
                        this.industryJson[id] = lottie.loadAnimation({
                            container: document.getElementById(id),
                            renderer: 'svg',
                            loop: true,
                            autoplay: true,
                            path: '/json/industries/V2/' + num + '/data.json?v=2'
                        });
                    }
                },
                stop: (elem) => {
                    var id = elem.attr('id');

                    if (typeof this.industryJson[id] !== 'undefined') {
                        this.industryJson[id].stop();
                    }
                }
            });
        });
    }
}

new Animation();